import '../../../../scss/image-editor.scss';
import '../../../../scss/critical.scss';
import { globalLogger } from '../../../qaamgo/helper/global-logger';

const $ = require('jquery');
global.$ = global.jQuery = $;

if (global.MODULE_LOADED_CROP_IMAGE) {
    globalLogger.log('double import');
} else {
    global.MODULE_LOADED_CROP_IMAGE = true;

    import(
        /* webpackMode: "eager" */
        '../../qg-main'
    ).then(function () {
        import('../../../qaamgo/modules/sat/pixie/pixie').then(function () {
            $(window).bind('beforeunload', function () {
                if (typeof window.allowLeave === 'undefined' || window.allowLeave !== true) {
                    return alertText;
                }
            });
            window.initImageEditor('edit', window.uploaderConfig);
        });
    });
}
